import { render, staticRenderFns } from "./UserReg.vue?vue&type=template&id=2afc1382"
import script from "./UserReg.vue?vue&type=script&lang=js"
export * from "./UserReg.vue?vue&type=script&lang=js"
import style0 from "./UserReg.vue?vue&type=style&index=0&id=2afc1382&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports